import Vue from 'vue'

import ElementUI from 'element-ui'
import VueI18n from 'vue-i18n'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import chinese from './zh'
import english from './en'

Vue.use(VueI18n)
const i18n=new VueI18n({
	locale:localStorage.getItem('lang')||'zh',		//语言标识
	silentTranslationWran:true,
	messages:{
		'zh':{
			...chinese,
			...zhLocale
		},
		'en':{
			...english,
			...enLocale
		}
	}
})
Vue.use(ElementUI,{
	i18n:(key,value)=>i18n.t(key,value)
})
export default i18n


// WEBPACK FOOTER //
// ./src/locale/index.js